export default "__VITE_ASSET__QuFXqNfv__"